class LinkedProducts extends HTMLElement {
  constructor() {
    super();
    this.onImageSwatchMouseEnterBound = this.onImageSwatchMouseEnter.bind(this);
    this.onImageSwatchMouseLeaveBound = this.onImageSwatchMouseLeave.bind(this);
    this.onImageSwatchClickBound = this.onImageSwatchClick.bind(this);
  }

  connectedCallback() {
    this.imageSwatchLabel = this.querySelector('.linked-products--title-wrapper .linked-option-product-title');
    this.imageSwatches = this.querySelectorAll('.swatch-element.image-swatch');

    this.setEventListeners();
    this.setActiveImageSwatchLabel();
  }

  setActiveImageSwatchLabel() {
    const selectedImageSwatch = this.querySelector('.swatch-element.image-swatch.active');
    if (!selectedImageSwatch) return;
    this.updateSwatchLabel(selectedImageSwatch);
  }

  updateSwatchLabel(swatch) {
    if (!swatch || !this.imageSwatchLabel) return;
    const label = swatch.getAttribute('data-value');
    if (!label) return;

    this.imageSwatchLabel.textContent = label;
    this.imageSwatchLabel.classList.remove('fade-in-label');
    void this.imageSwatchLabel.offsetWidth; // force reflow
    this.imageSwatchLabel.classList.add('fade-in-label');
  }

  setEventListeners() {
    if (!this.imageSwatches.length) return;
    this.imageSwatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.onImageSwatchMouseEnterBound);
      swatch.addEventListener('mouseleave', this.onImageSwatchMouseLeaveBound);
      swatch.addEventListener('click', this.onImageSwatchClickBound);
    });
  }

  onImageSwatchMouseEnter(event) {
    this.updateSwatchLabel(event.currentTarget);
  }

  onImageSwatchMouseLeave() {
    const activeSwatch = this.querySelector('.swatch-element.image-swatch.active');
    if (activeSwatch) this.updateSwatchLabel(activeSwatch);
    else if (this.imageSwatchLabel) this.imageSwatchLabel.textContent = '';
  }

  onImageSwatchClick(event) {
    const swatch = event.currentTarget;
    const variantId = swatch.querySelector('input')?.value;
    if (!variantId) return;

    const selector = document.querySelector('form[action="/cart/add"] [name="id"]');
    if (!selector) return;

    selector.value = variantId;
    selector.dispatchEvent(new Event('change', { bubbles: true }));

    // Refresh Judge.me after variant change
    refreshJudgeMe();
  }

  removeEventListeners() {
    this.imageSwatches.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.onImageSwatchMouseEnterBound);
      swatch.removeEventListener('mouseleave', this.onImageSwatchMouseLeaveBound);
      swatch.removeEventListener('click', this.onImageSwatchClickBound);
    });
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

// Define the custom element
if (!window.customElements.get('linked-products')) {
  window.customElements.define('linked-products', LinkedProducts);
}

// Refresh Linked Products images after Judge.me has loaded
function refreshLinkedProductsImages() {
  const linkedProducts = document.querySelectorAll('linked-products');
  linkedProducts.forEach(lp => {
    if (typeof lp.setActiveImageSwatchLabel === 'function') {
      lp.setActiveImageSwatchLabel();
    }
  });
}

// Call after Judge.me delay
const originalRefreshJudgeMe = refreshJudgeMe;
refreshJudgeMe = (delay = 500) => {
  originalRefreshJudgeMe(delay);
  setTimeout(refreshLinkedProductsImages, delay + 100); // slightly after Judge.me
};


// Lazy-load swatches
document.addEventListener('DOMContentLoaded', () => {
  const lazySwatches = document.querySelectorAll('.lazy-swatch');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const img = el.getAttribute('data-bg-img');
          if (img) {
            el.style.backgroundImage = `url(${img})`;
            el.style.backgroundSize = 'cover';
            el.style.backgroundPosition = 'center center';
            el.removeAttribute('data-bg-img');
          }
          obs.unobserve(el);
        }
      });
    }, { rootMargin: '50px' });
    lazySwatches.forEach(el => observer.observe(el));
  } else {
    lazySwatches.forEach(el => {
      const img = el.getAttribute('data-bg-img');
      if (img) el.style.backgroundImage = `url(${img})`;
    });
  }
});

// ✅ Judge.me helper
function refreshJudgeMe(delay = 300) {
  if (window.JudgeMeWidget && typeof window.JudgeMeWidget.render === 'function') {
    setTimeout(() => {
      window.JudgeMeWidget.render();
    }, delay);
  }
}

// Refresh Judge.me on Shopify variant changes
document.addEventListener('change', (event) => {
  if (event.target.name === 'id') {
    refreshJudgeMe();
  }
});

// Refresh Judge.me on form DOM changes (new variants, etc.)
document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;
  const observer = new MutationObserver(() => refreshJudgeMe());
  observer.observe(productForm, { childList: true, subtree: true });
});

// Refresh Judge.me when user jumps to reviews
window.addEventListener('hashchange', () => {
  if (window.location.hash === '#judgeme_reviews') {
    refreshJudgeMe();
  }
});
